import { importProvidersFrom } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * Factory function to create a TranslateHttpLoader for ngx-translate.
 * Loads translation files from the assets/i18n directory with .json extension.
 *
 * @param {HttpClient} http - The Angular HttpClient instance.
 * @returns {TranslateHttpLoader} The configured TranslateHttpLoader instance.
 */
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/**
 * Provides translation support for the Angular application using ngx-translate.
 * Registers the TranslateModule with a custom loader.
 *
 * @returns {Provider} The provider for translation module configuration.
 */
export function provideTranslations() {
  return importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  );
}
